module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-09 at 3.13.11 PM.7f1a1c64.png";